(() => {
  const ranges = {FL:[4,4],CA:[1,2],NV:[1,2],AZ:[1,2],UT:[2,3],ID:[2,3],OR:[2,3],WA:[3,3],CO:[3,3],WY:[3,3],NM:[2,3],TX:[3,4],MT:[3,4],ND:[3,4],SD:[3,4],NE:[3,4],KS:[3,4],OK:[3,4],AR:[3,4],LA:[3,4],MS:[3,4]};
  const excluded = new Set(['AK','HI','PR','GU','VI','AS','MP','AA','AE','AP','FM','MH','PW']);
  const chart = {1:[1,2,3,4,7],2:[1,2,3,6,7],3:[1,2,3,6,7],4:[1,2,3,6,7],5:[1,2,3,6,7]};
  const dayMs = 86400000;
  const dateKey = d => d.toISOString().slice(0,10);
  const addDays = (d,n) => new Date(d.getTime()+n*dayMs);
  const nthWeekday = (year,month,weekday,n) => {
    const first=new Date(Date.UTC(year,month,1));
    return dateKey(addDays(first,(weekday-first.getUTCDay()+7)%7+7*(n-1)));
  };
  const holidays = year => {
    const mayEnd=new Date(Date.UTC(year,4,31));
    return new Set([`${year}-01-01`,dateKey(addDays(mayEnd,-(mayEnd.getUTCDay()+6)%7)),`${year}-07-04`,nthWeekday(year,8,1,1),nthWeekday(year,10,4,4),`${year}-12-25`]);
  };
  const isClosed = (d,extra) => holidays(d.getUTCFullYear()).has(dateKey(d)) || extra.has(dateKey(d));
  const dispatchOpen = (d,extra) => d.getUTCDay()>0 && d.getUTCDay()<6 && !isClosed(d,extra);
  const nextDispatch = (d,extra) => {
    let next=addDays(d,1);
    while(!dispatchOpen(next,extra)) next=addDays(next,1);
    return next;
  };
  const arrival = (ship,days,extra,late) => {
    let end=addDays(ship,chart[ship.getUTCDay()][days-1]);
    for(let cursor=addDays(ship,1);cursor<=end;cursor=addDays(cursor,1)) {
      if(isClosed(cursor,extra)) end=addDays(end,1);
    }
    while(isClosed(end,extra) || (late && end.getUTCDay()===0)) end=addDays(end,1);
    return end;
  };
  const calculate = (now,range,cutoff,buffer,extra) => {
    const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
    let ship=new Date(`${parts.year}-${parts.month}-${parts.day}T00:00:00Z`);
    // Merchant display rule: no later than five business days after today's Pacific date.
    let cap=ship;
    for(let n=0;n<5;n++) cap=nextDispatch(cap,extra);
    if(!dispatchOpen(ship,extra) || Number(parts.hour)>=cutoff) ship=nextDispatch(ship,extra);
    let latestShip=ship;
    for(let n=0;n<buffer;n++) latestShip=nextDispatch(latestShip,extra);
    return [arrival(ship,range[0],extra,false),arrival(latestShip,range[1],extra,true)].map(date=>date>cap?cap:date);
  };
  const defaultArrival = now => {
    const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).map(p=>[p.type,p.value]));
    let date=new Date(`${parts.year}-${parts.month}-${parts.day}T00:00:00Z`);
    for(let days=0;days<2;) {
      date=addDays(date,1);
      if(date.getUTCDay()>0 && date.getUTCDay()<6 && !holidays(date.getUTCFullYear()).has(dateKey(date))) days++;
    }
    return date;
  };
  const normalize = value => {
    const clean=String(value||'').trim();
    return /^\d{5}(-\d{4})?$/.test(clean)?clean.slice(0,5):'';
  };
  let zipDataPromise;
  const getZips = url => {
    if(!zipDataPromise) zipDataPromise=fetch(url,{credentials:'omit'}).then(r=>{if(!r.ok) throw Error('ZIP data unavailable');return r.json();}).then(d=>d.zips).catch(e=>{zipDataPromise=null;throw e;});
    return zipDataPromise;
  };
  const savedZip = () => {try{return normalize(sessionStorage.getItem('mav_delivery_zip'));}catch{return '';}};
  const remember = zip => {try{sessionStorage.setItem('mav_delivery_zip',zip);}catch{}};
  const bind = (root=document) => {
    const cards=[...(root.matches?.('[data-mav-delivery]')?[root]:[]),...root.querySelectorAll('[data-mav-delivery]')];
    cards.forEach(card=>{
      if(card.dataset.bound) return;
      card.dataset.bound='true';
      if(!card.hasAttribute('data-regional')) {
        const native=card.querySelector('.delivery-promise__promise-container');
        if(!native) return;
        const update=()=>card.toggleAttribute('data-has-prediction',native.innerText.trim().length>0 && native.getBoundingClientRect().height>0);
        new MutationObserver(update).observe(native,{childList:true,subtree:true,characterData:true});
        new ResizeObserver(update).observe(native);update();return;
      }
      const strings=JSON.parse(card.querySelector('[data-delivery-strings]').textContent);
      const result=card.querySelector('[data-delivery-result]');
      const destination=card.querySelector('[data-delivery-destination]');
      const input=card.querySelector('[data-delivery-zip]');
      const button=card.querySelector('[data-delivery-update]');
      const error=card.querySelector('[data-delivery-error]');
      const details=card.querySelector('details');
      const extra=new Set((card.dataset.closures||'').split(/[\s,]+/).filter(v=>/^\d{4}-\d{2}-\d{2}$/.test(v)));
      const overrides = Object.fromEntries((card.dataset.transitOverrides || '92694:1').split(/[\n,]+/).map(line => line.trim().split(':')).filter(([zip,days]) => /^\d{5}$/.test(zip || '') && /^[1-5]$/.test(days || '')).map(([zip,days]) => [zip,Number(days)]));
      let zip='',state='',request=0;
      const render=()=>{
        const atc=card.closest('form')?.querySelector('button[name="add"],button[type="submit"]');
        if(atc?atc.disabled:card.dataset.available!=='true') {result.textContent=strings.unavailable;return;}
        if(state && excluded.has(state)){result.textContent=strings.unsupported;return;}
        const transitDays=overrides[zip] || (state?(ranges[state]||[4,5])[1]:5);
        const range=[transitDays,transitDays];
        const dates=calculate(new Date(),range,Number(card.dataset.cutoff),Number(card.dataset.buffer),extra);
        const formatter=new Intl.DateTimeFormat(document.documentElement.lang||'en-US',{timeZone:'UTC',weekday:'short',month:'short',day:'numeric'});
        result.textContent=formatter.format(zip?dates[1]:defaultArrival(new Date()));
      };
      const update=async (value,userAction=false,closeEditor=userAction)=>{
        const current=++request;
        const candidate=normalize(value);
        if(!candidate){error.textContent=strings.invalid;return;}
        error.textContent=strings.loading;button.disabled=true;
        try {
          const zips=await getZips(card.dataset.zipData);
          if(current!==request || !card.isConnected)return;
          if(!zips[candidate]){error.textContent=strings.invalid;return;}
          zip=candidate;state=zips[zip];input.value=zip;remember(zip);
          destination.textContent=strings.destination.replace('{zip}',zip);
          card.querySelector('[data-delivery-action]').textContent=strings.change;
          error.textContent='';render();
          if(userAction){if(closeEditor){details.open=false;details.querySelector('summary').focus();}document.dispatchEvent(new CustomEvent('mav:delivery-zip',{detail:{zip}}));}
        } catch {if(current===request)error.textContent=strings.error;}
        finally {if(current===request)button.disabled=false;}
      };
      let inputTimer;
      input.addEventListener('input',()=>{
        clearTimeout(inputTimer);
        request++;
        button.disabled=false;
        error.textContent='';
        if(normalize(input.value)) inputTimer=setTimeout(()=>update(input.value,true,false),250);
      });
      button.addEventListener('click',()=>{clearTimeout(inputTimer);update(input.value,true);});
      input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();event.stopPropagation();clearTimeout(inputTimer);update(input.value,true);}});
      document.addEventListener('mav:delivery-zip',event=>{if(card.isConnected && event.detail.zip!==zip)update(event.detail.zip);});
      document.addEventListener('mav:delivery-refresh',()=>{if(card.isConnected)render();});
      card.closest('form')?.addEventListener('change',()=>setTimeout(render,0));
      // Make the reference destination explicit until a shopper ZIP is known.
      input.value='85140';
      destination.textContent=strings.destination.replace('{zip}','85140')+' (default)';
      card.querySelector('[data-delivery-action]').textContent=strings.change;
      render();
      const initial=savedZip()||normalize(card.dataset.customerZip);
      if(initial)update(initial);
    });
  };
  bind();
  new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)bind(node);}).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',event=>bind(event.target));
  document.addEventListener('product-info:loaded',event=>bind(event.target));
  setInterval(()=>document.dispatchEvent(new Event('mav:delivery-refresh')),300000);
})();
